import { useContext } from 'react'
import ChartsContext from '@/contexts/ChartsContext'

const useCharts = () => useContext(ChartsContext)

export default useCharts
